<template>
  <task-page class="font-degular max-w-2xl" v-if="isDataLoaded">
    <task-list :shift="shift" :log="log" />
  </task-page>
</template>

<script>
import TaskList from '@/components/TaskList'
import TaskPage from '@/components/TaskPage'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'TasksView',
  components: {
    TaskList,
    TaskPage
  },
  computed: {
    ...mapState('config', ['isDataLoaded']),
    ...mapGetters('storeModule', ['currentLog', 'shifts']),
    ...mapGetters('storeModule/logs', ['logById']),
    ...mapGetters(['currentShift']),
    route: function () {
      return this.$route && this.$route.params && this.$route.params.shift
        ? this.$route.params.shift
        : null // error prevention
    },
    shift: function () {
      try {
        if (this.shifts && this.route) {
          return this.shifts.indexOf(this.route)
        }
        return this.currentShift || 0
      } catch (error) {
        return 0
      }
    },
    log() {
      return this.currentLog ? this.logById(this.currentLog) : null
    }
  }
}
</script>
